import { getTooltipValue, getInputValue, getInputName } from '../utils/Format';

export const getInputMetadata = (inputData, helpTextData, audienceType) => {
    const getTooltip = (id) => getTooltipValue(helpTextData, audienceType, id);
    const getVisible = (id) => getInputValue(inputData, audienceType, id);
    const getName = (id) => getInputName(inputData, audienceType, id);

    return {
        currentAge: { name: getName(1), visible: getVisible(1) },
        retirementAge: { name: getName(2), visible: getVisible(2) },
        currentComp: { name: getName(3), visible: getVisible(3), tooltip: getTooltip(1) },
        compRate: { name: getName(4), visible: getVisible(4), tooltip: getTooltip(6) },
        deferral: { name: getName(5), visible: getVisible(5), tooltip: getTooltip(7) },
        catchUp: { name: getName(6), visible: getVisible(6), tooltip: getTooltip(8) },
        current401: { name: getName(7), visible: getVisible(7), tooltip: getTooltip(9) },
        est401Return: { name: getName(8), visible: getVisible(8), tooltip: getTooltip(10) },
        beginningShares: { name: getName(9), visible: getVisible(9), tooltip: getTooltip(12) },
        shareIncrease: { name: getName(10), visible: getVisible(10), tooltip: getTooltip(14) },
        dividendIncrease: { name: getName(11), visible: getVisible(11), tooltip: getTooltip(15) },
        currentESOP: { name: getName(12), visible: getVisible(12), tooltip: getTooltip(17) },
        estESOPReturn: { name: getName(13), visible: getVisible(13), tooltip: getTooltip(18) }
    };
};